export default "__VITE_ASSET__ef9ef1fc__"